import React from 'react';
import PropTypes from 'prop-types';

import { SelectMenu, SelectMenuItem as MenuItem, SelectSubtitle as Subtitle } from '../styles';

const Menu = ({ onSelect, options = [] }) => (
  <SelectMenu>
    {options.map((option, index) => (
      <MenuItem key={`${option.value}-${index}`}>
        <button type="button" onClick={() => onSelect(option)}>
          <span>{option.label}</span>
          {option.subtitle ? <Subtitle>{option.subtitle}</Subtitle> : null}
        </button>
      </MenuItem>
    ))}
  </SelectMenu>
);

Menu.propTypes = {
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
};

export default Menu;
